// extracted by mini-css-extract-plugin
module.exports = {"body":"body--3J4KC","row":"row--171_L","qtd":"qtd--2eXqU","lot":"lot--xrVuD","shelf_life":"shelf_life--ND6qd","product":"product--28tbx","observation":"observation--1Jsma"};